import { Button, Card } from '@zenid/web';
import { useCallback, useMemo, useState } from 'react';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';
import { IntegrationConsent } from './IntegrationConsent';

// サブメールアドレスの追加は取り消せないため、実行前に同意を得る
const CONSENT_MESSAGE = '一度追加すると、キャンセルすることはできません';

type Props = {
  execute: () => Promise<void>;
};

export function IntegrationExecuteConsent({ execute }: Props) {
  const [consented, setConsented] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const disabled = useMemo(() => !consented || submitting, [consented, submitting]);

  const handleSubmit = useCallback(async () => {
    if (disabled) {
      return;
    }
    setSubmitting(true);
    await execute();
    setSubmitting(false);
  }, [disabled, execute]);

  return (
    <Card
      className={css({
        width: '343px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.20}',
        sm: { width: '400px', padding: '{spacing.40}' },
      })}
    >
      <div className={flex({ flexDirection: 'column', gap: '{spacing.16}' })}>
        <h1
          className={css({
            textStyle: 'headding.l',
            textAlign: 'center',
            color: '{colors.text.main}',
            wordBreak: 'keep-all',
          })}
        >
          サブメールアドレスを追加します
        </h1>
        <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}' })}>
          メールアドレスの確認が完了しました。以下の内容をご確認のうえ、サブメールアドレスの追加を実行してください。
        </p>
        <IntegrationConsent message={CONSENT_MESSAGE} checked={consented} onChange={setConsented} />
      </div>
      <Button
        color="primary"
        size="l"
        stretch="container"
        disabled={disabled}
        onClick={handleSubmit}
        className={css({ marginTop: '{spacing.24}' })}
      >
        サブメールアドレスを追加する
      </Button>
    </Card>
  );
}
